import type React from 'react';
import { createContext } from 'react';

import type { Conversation, Message } from '@/features/ai-chat/types/chat.types';

export interface ChatContextValue {
  messages: Message[];
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
  restoreConversation: (conversation: Conversation) => void;
  inputMessage: string;
  setInputMessage: React.Dispatch<React.SetStateAction<string>>;
  handleSend: () => void;
  sendMessage: (text: string, options?: { addHuman?: boolean }) => void;
  isInitializing: boolean;
  isSending: boolean;
  setConversationId: (conversationId: string | null) => void;
  conversationId: string | null;
  version: number;
  // Animated shared prompt support
  animatedHumanId?: string | null;
  animatedText?: string | null;
  onAnimatedComplete?: () => void;
}

export const ChatContext = createContext<ChatContextValue | undefined>(undefined);
